import ModalWrapper from './common/Modal.tsx';
import { ReactNode } from 'react';
import LanguageWrapper from '@/common/Language.tsx';

function Page({ children }: { children: ReactNode }) {
  return (
    <>
      <LanguageWrapper>
        <ModalWrapper>{children}</ModalWrapper>
      </LanguageWrapper>

      {/* Mobile screen size warning - hidden on desktop (md and up) */}
      <div className="fixed inset-0 z-[9999999] flex items-center justify-center bg-gray-100 p-8 lg:hidden">
        <div className="text-center">
          <p className="text-lg font-medium">
            This app is optimized for desktop screens, please open on a bigger
            screen.
          </p>
        </div>
      </div>
    </>
  );
}

export default Page;
